"use strict";
var documentCreateElement = require("../internals/document-create-element");
var classList = documentCreateElement("span").classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
module.exports = DOMTokenListPrototype === Object.prototype ? void 0 : DOMTokenListPrototype;
